import React from 'react'
import './styles.scss'

const glaciers = {
  'Grosser Aletsch': require('../main/img/grosser_aletschgletscher.svg'),
  Gorner: require('../main/img/gornergletscher.svg'),
  Unteraar: require('../main/img/unteraargletscher.svg'),
  Oberaletsch: require('../main/img/oberaletschgletscher.svg'),
  'Unterer Grindelwald': require('../main/img/unterer_grindelwaldgletscher.svg'),
  'Mont Collon': require('../main/img/glacier_du_mont_collon.svg'),
  Fiescher: require('../main/img/fieschergletscher_vs.svg'),
  Otemma: require('../main/img/glacier_d_otemma.svg'),
  Findelen: require('../main/img/findelengletscher.svg'),
  Zmutt: require('../main/img/zmuttgletscher.svg'),
  Stein: require('../main/img/steingletscher.svg'),
  Corbassière: require('../main/img/glacier_de_corbassiere.svg'),
  Morteratsch: require('../main/img/vadret_da_morteratsch.svg'),
  Ferpècle: require('../main/img/glacier_de_ferpecle.svg'),
  'Plaine Morte': require('../main/img/glacier_de_plaine_morte.svg'),
  Rhone: require('../main/img/rhonegletscher.svg'),
  Trift: require('../main/img/triftgletscher.svg'),
  Forno: require('../main/img/vadrec_del_forno.svg'),
  Zinal: require('../main/img/glacier_de_zinal.svg'),
  Lang: require('../main/img/langgletscher.svg'),
  Brenay: require('../main/img/glacier_du_brenay.svg'),
  Kanderfirn: require('../main/img/kanderfirn.svg'),
  Roseg: require('../main/img/vadret_da_roseg.svg'),
  Tschierva: require('../main/img/vadret_da_tschierva.svg'),
  Saleina: require('../main/img/glacier_de_saleina.svg'),
  Palü: require('../main/img/vadret_da_palue.svg'),
  'Mont Durand': require('../main/img/glacier_du_mont_durand.svg'),
  Schwarzberg: require('../main/img/schwarzberggletscher.svg'),
  'Mont Miné': require('../main/img/glacier_du_mont_mine.svg'),
  Hüfifirn: require('../main/img/huefifirn.svg'),
  Tschingelfirn: require('../main/img/tschingelfirn.svg'),
  Moming: require('../main/img/glacier_de_moming.svg'),
  Allalin: require('../main/img/allalingletscher.svg'),
  'Oberer Grindelwald': require('../main/img/oberere_grindelwaldgletscher.svg'),
  Ried: require('../main/img/riedgletscher.svg'),
  Rosenlaui: require('../main/img/rosenlauigletscher.svg'),
  Trient: require('../main/img/glacier_du_trient.svg'),
  Giétro: require('../main/img/glacier_du_gietro.svg')
}

export default function glacier(props) {
  const lossArea = Math.round(props.l * 10) / 10
  const lossPercentage = Math.round(props.p * 10) / 10
  const dangerGrade = lossPercentage <= -30 ? 'highlight' : 'normal'

  return (
    <div className='glacier-wrapper'>
      <div className='glacier-name'>
        <span>{props.n}</span>
        <div className='canton'>{props.k}</div>
      </div>
      <div className='stats'>
        <div className='glacier-loss'>{lossArea} km&sup2;</div>
        <div className='glacier-percentage'>
          <span className={`${dangerGrade}`}>{lossPercentage}%</span>
        </div>
      </div>
      <div className='glacier-shape'>
        <img src={glaciers[props.n]} alt='' className='ui fluid image' />
      </div>
    </div>
  )
}
